import React, { useContext } from "react";
import axios from "axios";

//MUI Imports
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

//React Router
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import ReservationForm from "components/Forms/ReservationForm/ReservationForm";
import Policies from "components/Policies/Policies";

// userContext import
import { CurrentUserContext } from "context/UserContext";

const ReservationPage = () => {
  const { id } = useParams(); // Parametro de la url
  const [product, setProduct] = React.useState(null);
  const [occupation, setOccupation] = React.useState([]);
  const [userContextData] = useContext(CurrentUserContext);
  const user = userContextData;

  //API CALL
  React.useEffect(() => {
    const fetchProduct = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/${id}`
        );
        setProduct(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchProduct();
  }, [id]);

  //API CALL
  React.useEffect(() => {
    const fetchOccupation = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/${id}/reservations`
        );

        const occupationData = resultado.data.map((reservation) => ({
          start: new Date(`${reservation.start_date.slice(0, 10)}T00:00:00Z`),
          end: new Date(`${reservation.end_date.slice(0, 10)}T12:00:00Z`),
        }));
        setOccupation(occupationData);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchOccupation();
  }, [id]);

  return product ? (
    <>
      <div className="productPage__container">
        <div className="productPage__container__header">
          <div className="productPage__container__header__text">
            <p className="productPage__container__header__text__category">
              {product.category.title}
            </p>
            <p className="productPage__container__header__text__name">
              {product.title}
            </p>
          </div>
          <div className="productPage__container__header__icon">
            <Link to={`/product/${id}`}>
              <ArrowBackIosIcon sx={{ fontSize: 40, color: "white" }} />
            </Link>
          </div>
        </div>
        <div className="reservation__container">
          <ReservationForm
            user={user}
            product={product}
            occupation={occupation}
          />
        </div>
        <Policies reservation />
      </div>
    </>
  ) : (
    <div className="productPage__container">
      <h2 className="product__loading">Loading data...</h2>
    </div>
  );
};

export default ReservationPage;
